import { exportHack } from '../../utils/exportHack';
import { borderTypes, labelTypes, sizes, } from '../Select/constants';
import { SelectCustom, } from './SelectCustom';
import { SelectCustomOption, } from './SelectCustomOption';
import { SelectCustomOptionGroup, } from './SelectCustomOptionGroup';
const ExportHackSelectCustom = (exportHack({
    component: SelectCustom,
    constants: {
        borderTypes,
        labelTypes,
        Option: SelectCustomOption,
        OptionGroup: SelectCustomOptionGroup,
        sizes,
    },
}));
export { ExportHackSelectCustom as SelectCustom, SelectCustomOption, SelectCustomOptionGroup, };
